const env = process.env.REACT_APP_ENV || 'development';
const isEnterprise = process.env.REACT_APP_ENTERPRISE || true;
const isMMI = window.location.href.includes('mmi');

let API_URL;
let ICSC_ORG;
switch (true) {
  case env === 'production':
    API_URL = isEnterprise
      ? 'https://enterprise-api.adventuresincre.com/api'
      : 'https://api.adventuresincre.com/api';
    ICSC_ORG = 'icsc';
    break;
  case env === 'local-prod':
    API_URL = 'http://206.189.231.114:3005/api';
    break;
  case env === 'staging':
    API_URL = isEnterprise
      ? 'https://staging-enterprise-api.adventuresincre.com/api'
      : 'https://staging-api.adventuresincre.com/api';
    break;
  default:
    API_URL = isEnterprise
      ? 'http://localhost:3007/api'
      : 'http://localhost:3005/api';
    ICSC_ORG = 'test-rrr';
    break;
}

const MEMBERSHIP = {
  ACCELERATOR_CORE: 2,
};

export { API_URL, isEnterprise, MEMBERSHIP, ICSC_ORG, isMMI };
